import React, { FC } from "react";
import { Button, makeStyles } from "@material-ui/core";
import { TheCycleverseTheme } from "src/theme";
import { handleScroll } from "src/lib/handleScroll";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  scrollDownBtnContainer: {
    textAlign: "center",
    marginTop: "30px",
    marginBottom: "30px",
    cursor: "pointer",
  },

  centeredCalculatorButton: (whiteBackground) => {return {
    backgroundColor: whiteBackground ? theme.buttonColor : theme.buttonBackgroundColor,
    color: whiteBackground ? theme.buttonBackgroundColor : theme.buttonColor,
    textAlign: "center",
    "&:hover": {
      backgroundColor: theme.buttonBackgroundColor,
      color: theme.buttonColor
    },
  }},
}));

export const CalculatorButton: FC<{
  idToScrollTo?: string;
  onClick?: () => void;
  text: string;
  scroll?: boolean;
  whiteBackground?: boolean
}> = ({ onClick, text, idToScrollTo, scroll = false, whiteBackground = false }) => {
  const classes = useStyles(whiteBackground);

  return (
    <div className={classes.scrollDownBtnContainer}>
      <Button
        className={classes.centeredCalculatorButton}
        onClick={scroll ? () => handleScroll(idToScrollTo) : onClick}
      >
        {text}
      </Button>
    </div>
  );
};
